module.exports = __webpack_public_path__ + "img/IMG_1401_L_Foamcore.e5363567.jpg";